var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMinusCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8916 11.3333H6.55827V9.66666H14.8916M10.7249 2.16666C9.63059 2.16666 8.54695 2.3822 7.53591 2.80099C6.52486 3.21978 5.6062 3.83361 4.83238 4.60743C3.26958 6.17024 2.3916 8.28985 2.3916 10.5C2.3916 12.7101 3.26958 14.8297 4.83238 16.3925C5.6062 17.1664 6.52486 17.7802 7.53591 18.199C8.54695 18.6178 9.63059 18.8333 10.7249 18.8333C12.9351 18.8333 15.0547 17.9553 16.6175 16.3925C18.1803 14.8297 19.0583 12.7101 19.0583 10.5C19.0583 9.40564 18.8427 8.32201 18.4239 7.31096C18.0051 6.29991 17.3913 5.38125 16.6175 4.60743C15.8437 3.83361 14.925 3.21978 13.914 2.80099C12.9029 2.3822 11.8193 2.16666 10.7249 2.16666Z",
    fill: "#DC3545"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusCircle);
export default __webpack_public_path__ + "static/media/MinusCircle.6c96ebb2.svg";
export { ForwardRef as ReactComponent };